<div class="parent w-100">
  <div id="headers">
    <ol class="d-flex justify-content-between stepper-list m-0 p-0">
      @for (step of steps; track step.id; let i = $index) {
        <li class="stepper-list-item" appStepHeader [step]="i" [activeStep]="activeStep" [label]="step.label" [id]="step.id"></li>
      }
    </ol>
  </div>
</div>

<div>
  <ng-content></ng-content>
</div>
